module.exports = __webpack_public_path__ + "media/images/font/pepsiowners2-compressed220909-3079df098dc835057500d28eff98463d.woff2";